import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "main-view-container" }

import SideBar from '@/components/layout/SideBar';
import MobileMenu from '@/components/layout/MobileMenu'
import {useRoute} from "vue-router";
import {ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()

const displayMobileMenu = ref(false);

const toggleMobileMenuDisplay = () => {
  displayMobileMenu.value = !displayMobileMenu.value
}

return (_ctx: any,_cache: any) => {
  const _component_base_header = _resolveComponent("base-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_base_footer = _resolveComponent("base-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createVNode(_component_base_header, { onToggleMobileMenuDisplay: toggleMobileMenuDisplay })
    ]),
    _createElementVNode("main", null, [
      (displayMobileMenu.value)
        ? (_openBlock(), _createBlock(_unref(MobileMenu), {
            key: 0,
            onClick: toggleMobileMenuDisplay
          }))
        : _createCommentVNode("", true),
      _createVNode(_unref(SideBar), { class: "side-bar" }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", null, _toDisplayString(_unref(route).name), 1),
        _createVNode(_component_router_view)
      ])
    ]),
    _createElementVNode("footer", null, [
      _createVNode(_component_base_footer)
    ])
  ]))
}
}

})